/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import axios from 'axios/dist/axios.min.js'
import CountDown from './components/CountDown';
import Games from './components/Games';
import PrizesList from "./components/PrizesList";
import utils from '../../utils/utils';
import "./style.less";

class PipelineGames extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogin: false,   // 是否已登录
      prize_list: [],   // 老虎机奖品列表
      draw: {},         // 场次信息
      show: false,      // 是否展示游戏弹窗
      count: 0,         // 剩余抽奖次数，为0时也不展示游戏弹窗
      record: [],       // 中奖记录
      result: {},       // 中奖结果
      show_toast: false,
      toast_text: '',
      startSlotMachine: false
    };
    this.interval = null;
    this.loginInterval = null;
  }

  componentDidMount() {

    this.createScript();

    const { baseConfig } = this.props.config;
    this.unique_id = baseConfig.uniqueId;
    // 获取本地Cookie
    if (utils.isShihuo()) { 
      const CookieUA = utils.getCookie('ua');
      const CookieU = utils.getCookie('u');
      Promise.all([CookieUA, CookieU]).then(result => {
        this.setState({
          isLogin: result && result[0] && result[1]
        });
      })

      // 获取设备信息
      let device_info = {};
      window.Jockey.send("device", (res) => {
        if (typeof res == "string") {
          res = JSON.parse(res);
        }
        device_info = Object.assign(device_info, res);
        this.abtest_tag = device_info.abtest_tag || "";
        this.getActivityDetail();
        this.queryDrawUsage();
        this.queryWinningRecord();
      }); 
    } else {
      this.getActivityDetail();
      this.queryDrawUsage();
      this.queryWinningRecord();
    }
  }

  componentWillUnmount() {
    this.loginInterval && clearInterval(this.loginInterval);
    this.loginInterval = null;
  }

  // 查询是否登录
  queryIsLogin = () => {
    this.loginInterval && clearInterval(this.loginInterval);
    this.loginInterval = setInterval(() => {
      const { isLogin } = this.state;
      if (!isLogin) {
        const CookieUA = utils.getCookie('ua');
        const CookieU = utils.getCookie('u');
        Promise.all([CookieUA, CookieU]).then(result => {
          this.setState({
            isLogin: result && result[0] && result[1]
          });
        })
      } else {
        this.loginInterval && clearInterval(this.loginInterval);
        this.loginInterval = null;
      }
    }, 1000);
  }

  // 活动详情
  getActivityDetail = () => {
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/info?access_token=&unique_id=' + this.unique_id,
      method: 'get',
      headers: {
        "Abtest-Control": this.abtest_tag,
      },
      withCredentials: true,
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        const { prize_list, draw, show } = data;
        this.setState({
          prize_list,
          draw,
          show: show === 1
        })
      }
    })
  }

  // 查询抽奖次数
  queryDrawUsage = () => {
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/usage?&unique_id=' + this.unique_id,
      method: 'get',
      headers: {
        "Abtest-Control": this.abtest_tag,
      },
      withCredentials: true,
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        this.setState({
          count: data.count
        });
      } else {
        this.setState({
          count: 2
        });
      }
    })
  }

  // 抽奖
  handleLuckyDraw = () => {
    if (typeof window !== 'undefined') {
      window.__dace.sendEvent('draw_gift', {
        from: "topic_page_game_sale",
        block: "draw_gift"
      }); 
    }
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/start?unique_id=' + this.unique_id,
      method: 'post',
      withCredentials: true,
      data: {
        unique_id: this.unique_id,
      },
      headers: {
        "Abtest-Control": this.abtest_tag,
      }
    }).then(res => {
      const { status, msg, data } = res.data;
      if (status == 0) {
        if (data.winning) {
          // 中奖了，查询奖品列表
          this.setState({
            result: data,
            startSlotMachine: true
          });
          this.queryWinningRecord();
        } else {
          // 未中奖，如何处理？（动画是否播放）

        }
      } else {
        this.setState({
          show_toast: true,
          toast_text: msg
        });
      }
    })
  }

  // 查询中奖记录
  queryWinningRecord = () => {
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/record?&unique_id=' + this.unique_id,
      method: 'get',
      headers: {
        "Abtest-Control": this.abtest_tag,
      },
      withCredentials: true,
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        const { list } = data;
        this.setState({
          record: list
        });
      }
    })
  }

  handleItemClick = () => {
    window.__dace.sendEvent('new_user_redpacket', {
      from: 'make_up_land_page',
      block: 'new_user_redpacket',
    });
  };

  renderCouponsList = () => {
    const { coupon_list, expire_time } = this.state;
    const { couponsConfig } = this.props.config;
    return (
      <div className="coupons-info" style={{backgroundColor: couponsConfig.couponBackgroundColor}}>
        <p className="title">{couponsConfig.couponTitle}</p>
        <div className="coupon-list">
          <div className="scroll">
            <ul>
              {
                coupon_list.map((item, index) => {
                  return (
                    <div className="coupon-item" key={index}>
                      <img src={utils.formatImgUrl(couponsConfig.couponBackgroundImage, this.props.webpSupport)} alt="" />
                      <div className="content">
                        <p className="money"><span>￥</span>{parseFloat(item.cash_back)}</p>
                        <p className="desc">{parseFloat(item.start_amount) > 0 ? `满${parseFloat(item.start_amount)}返` : '无门槛'}</p>
                      </div>
                    </div>
                  )
                })
              }
            </ul>
          </div>
        </div>
        {
          !couponsConfig.noCountDown && (
            <p className="count-down">
              <CountDown end_time={expire_time} />
            </p>
          )
        }
      </div>
    )
  }

  render() {
    const { isLogin, prize_list, show, count, record, result, startSlotMachine } = this.state;
    return (
      <div
        className="pipeline-games-coupons"
        {...this.props['customAttributes']}
      >
        {
          show && count > 0 && (
            <Games
              visable={show && count > 0}
              prize_list={prize_list}
              unique_id={this.unique_id}
              abtest_tag={this.abtest_tag}
              info={result}
              isLogin={isLogin}
              config={this.props.config}
              startSlotMachine={startSlotMachine}
              showToast={this.showToast}
              login={this.login}
              queryWinningRecord={this.queryWinningRecord}
              handleLuckyDraw={this.handleLuckyDraw}
              closeGame={this.closeGame}
            />
          )
        }
        {
          record && record.length > 0 && record.map((item, index) => {
            if (item.recevied != 0 && item.prize_type != 2) {
              return (
                <PrizesList
                  key={index}
                  unique_id={this.unique_id}
                  abtest_tag={this.abtest_tag}
                  info={item}
                  isLogin={isLogin}
                  config={this.props.config}
                  showToast={this.showToast}
                  login={this.login}
                  queryWinningRecord={this.queryWinningRecord}
                />
              )
            } else {
              return null
            }
          })
        }
        { this.renderToast() }
      </div>
    );
  }

  renderToast = () => {
    const { show_toast, toast_text } = this.state;
    if (show_toast) {
      this.interval && clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        this.setState({
          show_toast: false,
          toast_text: ''
        });
      }, 2500);
      return <p className="toast">{toast_text}</p>;
    } else {
      return null;
    }
  }

  showToast = (show_toast, toast_text) => {
    this.setState({
      show_toast,
      toast_text
    })
  }

  login = () => {
    if (utils.isShihuo()) {
      // 未登陆，请先进行微信登陆
      window.Jockey.send("subscribe", {}, (publishData) => {
        if (publishData.type === "loginSuccess") {
          this.queryIsLogin();
        }
      });
      window.Jockey.send("action", {
        url: "shihuo://www.shihuo.cn?route=login",
      });
    }
  }

  closeGame = () => {
    this.setState({
      show: false
    })
  }

  createScript = () => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.type = "text/javascript";
    script.src = "https://www.shihuo.cn/js/lib/vFramePlayer.min.js";
    head.appendChild(script);
  }

}

export { PipelineGames };
export default PipelineGames;



// WEBPACK FOOTER //
// ./components/pipeline-games/index.js